<template>
  <div class="overview">
    <v-card flat>
      <v-card-text>
        <DataTable
          :key="tableKey"
          :optionsPassed="options"
          :totalRules="totalRules"
          :rules="rules"
          :searchPassed="search"
          :headerSelects="headerSelects"
          :headersTable="headersTable"
          v-on:getCommunicationRules="getCommunicationRules"
          @deleteRule="deleteRule"
          :loading="loading"
        >
          <template #title>
            <!-- <v-icon left>mdi-filter</v-icon> -->
            Defined Rules Overview
          </template>
          <template #headerButtons>
            <v-btn
              color="primary"
              class="mr-2"
              small
              to="/addRule"
              :loading="downloadLoading"
            >
              Create Rule
            </v-btn>
            <v-btn class="mr-2" small :loading="downloadLoading">
              Cancel
            </v-btn>
          </template>
        </DataTable>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
// UI uses `documentType`, backend uses `serviceRequestType`

import { ExportType, StatusCode } from "@/enums";
import DataTable from "./CommunicationRulesTable.vue";

// var searchTimeOut;

export default {
  name: "CommunicationRules",
  components: {
    DataTable,
  },
  data: () => ({
    rules: [],
    search: {
      organisation: null,
      country: null,
      sbmProfile: null,
      serviceGrade: null,
      productGroup: null,
      documentNrs: "",
      infoLevel: "",
      activeDateFrom: null,
      activeDateTo: null,
      documentType: null,
    },
    options: {
      /*itemsPerPage: 15*/
    },
    totalRules: null,
    headerSelects: {
      documentType: [],
      status: [],
      organisation: [],
      country: [],
      sbmProfile: [],
      serviceGrade: [],
      productGroup: [],
      productSubGroup: [],      
      infoLevel: [],
    },

    allHeaders: [
      { text: "Organisation", value: "organisation", type: "select", class: "text-subtitle-1 font-weight-bold" },
      { text: "Type", value: "documentType", type: "select", class: "text-subtitle-1 font-weight-bold" },
      { text: "Country", value: "country", type: "select", class: "text-subtitle-1 font-weight-bold" },
      { text: "SBM Profile", value: "sbmProfile", type: "select", class: "text-subtitle-1 font-weight-bold" },
      { text: "Service Grade", value: "serviceGrade", type: "select", class: "text-subtitle-1 font-weight-bold" },
      { text: "Product Group", value: "productGroup", type: "select", class: "text-subtitle-1 font-weight-bold" },
      { text: "Document nrs", value: "documentNrs", type: "text", class: "text-subtitle-1 font-weight-bold" },
      { text: "Info Level", value: "infoLevel", type: "select", class: "text-subtitle-1 font-weight-bold" },
      { text: "Active Date From", value: "activeDateFrom", type: "date", class: "text-subtitle-1 font-weight-bold" },
      { text: "Active Date To", value: "activeDateTo", type: "date", class: "text-subtitle-1 font-weight-bold" },
      { text: "", value: "actions", sortable: false, align: "center", width: "50px" }
    ],
    loading: false,
    downloadLoading: false,
  }),
  computed: {
    headersTable() {
      if (this.search.documentType === 24) {
        return this.allHeaders.filter(
          h => h.value !== 'serviceGrade'
        );
      }
      return this.allHeaders;
    },

    tableKey() {
      return this.search.documentType || 'default';
    },
  },
  methods: {
    getCommunicationRules(tableSearch) {
      this.loading = true;

      this.search = tableSearch.search;
      this.options = tableSearch.options;

      const apiSearch = {
        ...tableSearch.search,
        serviceRequestType: tableSearch.search.documentType
      };

      // documentType niet naar backend sturen
      delete apiSearch.documentType;

      this.$api
        .getCommunicationRules({
          search: apiSearch,
          options: tableSearch.options,
          ignoreServiceLimitTime: tableSearch.ignoreServiceLimitTime
        })
        .then((resp) => {
          // 🔁 Mapping backend → UI
          this.rules = resp.data.rules.map(rule => ({
            ...rule,
            documentType: rule.serviceRequestType
          }));

          this.totalRules = resp.data.totalRules;
        })
        .catch(err => {
          console.error("❌ Error fetching communication rules:", err);
        })
        .finally(() => {
          this.loading = false;
        });
    },    
    async deleteRule(item) {
      const confirmed = await this.$confirm(
        `Are you sure you want to delete this item?`
      );
      if (!confirmed) return;

      try {
        this.loading = true;
        await this.$api.deleteCommunicationRule(item.id);

        this.rules = this.rules.filter((e) => e.id !== item.id);
        this.totalRules;
      } catch (error) {
        console.error(error);
        alert("Failed to delete rule");
      } finally {
        this.loading = false;
      }
    },
    download() {
      this.downloadLoading = true;
      this.$api
        .downloadOverview(
          ExportType.excel,
          StatusCode.inProgress,
          this.search,
          true
        )
        .finally(() => (this.downloadLoading = false));
    },
  },

  mounted() {
    this.$api.getAllowedInfoLevels().then(resp => {
      this.headerSelects.infoLevel = resp.data.map(level => ({
        value: level,
        text: level
      }));
    });
  },
  watch: {
    'search.documentType'(newVal) {
    if (newVal === 24) {
      this.search.serviceGrade = null;
    }
  },
    $route(to) {
      if (to.name === "CommunicationRules") {
        this.getCommunicationRules({
          search: this.search || {},
          options: this.options || {},
        });
      }
    },
  },
};
</script>
